module.exports = __webpack_public_path__ + "img/modal-header-bg.078c2b7f.svg";